import script from "./Roles.vue?vue&type=script&lang=ts&setup=true"
export * from "./Roles.vue?vue&type=script&lang=ts&setup=true"

import "./Roles.vue?vue&type=style&index=0&id=a2e36f26&lang=scss"

const __exports__ = script;

export default __exports__